var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pop-dim"},[_c('div',{staticClass:"pop-wrap"},[_c('h2',[_vm._v("오류발생")]),_vm._m(0),_c('button-item',{attrs:{"btnText":'확인',"btnClass":'layerpop-btn'},on:{"click":_vm.onCancel}}),_c('div',{staticClass:"pop-close"})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("\n      오류가 발생하였습니다. 잠시 후 다시 시도해 주세요.\n      "),_c('br'),_vm._v("계속해서 오류가 발생한다면 문의주시기 바랍니다.\n    ")])
}]

export { render, staticRenderFns }